import '../../common/bn-action';
import '../../common/bn-loading';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';

class WorkOrderDiagnosis extends LitEntity {
  static get styles() {
    return css`
      bn-action + bn-action {
        margin-top: 2em;
      }
    `;
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      ${renderIf(this.entity.hasActionByName('update-pre-diagnosis'), () => html`
        <bn-action
          .href="${this.href}"
          actionname="update-pre-diagnosis"
          successtext="Pre Diagnosis Updated"
          errortext="An error occurred when trying to update the pre diagnosis."
          submittext="Save"
        >
          <span slot="header"></span>
        </bn-action>
      `)}
      ${renderIf(this.entity.hasActionByName('update-field-diagnosis'), () => html`
        <bn-action
          .href="${this.href}"
          actionname="update-field-diagnosis"
          successtext="Field Diagnosis Updated"
          errortext="An error occurred when trying to update the field diagnosis."
          submittext="Save"
        >
          <span slot="header"></span>
        </bn-action>
      `)}
      ${renderIf(this.entity.hasActionByName('update-field-action'), () => html`
        <bn-action
          .href="${this.href}"
          actionname="update-field-action"
          successtext="Field Action Updated"
          errortext="An error occurred when trying to update the field action."
          submittext="Save"
        >
          <span slot="header"></span>
        </bn-action>
      `)}
    `;
  }
}

customElements.define('work-order-diagnosis', WorkOrderDiagnosis);
